import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PartnerOffer} from '../../models/partner/partner-offer';

@Injectable({
  providedIn: 'root'
})
export class PartnerOfferService extends AbstractModelService<PartnerOffer> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner-offer', PartnerOffer);
  }
}
